import Carousel from 'global/carousel.src';

import startFreeTrialForm from 'global/free-trial-form-multiple.src';

(function ready(fn) {
    if (document.readyState !== 'loading') {
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
})(() => {
    [].forEach.call(document.querySelectorAll('.free-trial-form'), (form) => {
        startFreeTrialForm.init(form);
    });

    /**
     * Carousel
     */
    [].forEach.call(document.querySelectorAll('.carousel'), (item) => {
        const c = new Carousel(item);
    });

    /**
     * Tabbed
     */
    [].forEach.call(document.querySelectorAll('.tabbed-sections'), (tabbedSection) => {
        [].forEach.call(tabbedSection.querySelectorAll('h3 > a'), (el) => {
            el.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                if (tabbedSection.querySelector(el.getAttribute('href')).classList.contains('current')) {
                    return;
                }
                tabbedSection.querySelector('h3.current').classList.remove('current');
                el.parentElement.classList.add('current');
                const currentSection = tabbedSection.querySelector('section.current');
                if (tabbedSection.querySelector('section.hide')) {
                    tabbedSection.querySelector('section.hide').classList.remove('hide');
                }
                if (tabbedSection.querySelector('section.show')) {
                    tabbedSection.querySelector('section.show').classList.remove('show');
                }
                currentSection.classList.remove('current');
                currentSection.classList.add('hide');

                tabbedSection.querySelector(el.getAttribute('href')).classList.add('show');
                tabbedSection.querySelector(el.getAttribute('href')).classList.add('current');
            });
        });
    });
    /**
     * END: Tabbed
     */
});
